import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { QrReader } from 'react-qr-reader';
import { isNil } from 'ramda';
import { MdReplay } from 'react-icons/md';

import Modal from './Modal';
import BoardgameCard from './BoardgameCard';

class ScanQrModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scannedCode: null,
    };

    this.onCloseModal = this.onCloseModal.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleScan = this.handleScan.bind(this);
    this.reset = this.reset.bind(this);
    this.scannedBoardgame = this.scannedBoardgame.bind(this);
  }

  onCloseModal() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  reset() {
    this.setState({ scannedCode: null });
  }

  handleError(error) {
    console.log(error);
  }

  handleScan(data) {
    if (data) {
      this.setState({ scannedCode: data });
    }
  }

  scannedBoardgame() {
    return this.state.scannedCode && this.props.boardgamesById[this.state.scannedCode];
  }

  render() {
    const scannedBoardgame = this.scannedBoardgame();
    return (
      <Modal isOpen={this.props.isOpen} onClose={this.onCloseModal} title="Scansiona">
        <div className="w-full">
          <div className="flex flex-wrap -mx-3 mb-2">
            {
              isNil(scannedBoardgame) && isNil(this.state.scannedCode) && this.props.isOpen &&
                <QrReader
                  delay={500}
                  onError={this.handleError}
                  onScan={this.handleScan}
                  style={{ width: '100%' }} />
            }

            { 
              !isNil(scannedBoardgame) && !isNil(this.state.scannedCode) &&
                <BoardgameCard
                  {...scannedBoardgame}
                  showActions={true}
                  onReserveBoardgame={this.props.reserveBoardgame}
                  onGetBackBoardgame={this.props.getBackBoardgame} />
            }

            {
              isNil(scannedBoardgame) & !isNil(this.state.scannedCode)
                ? <h1 className="text-center text-2xl font-serif font-black w-full mb-4">Non è stato possibile trovare il gioco!</h1>
                : null
            }
            {
              !isNil(this.state.scannedCode)
                ? <button type="button" className={`bg-gray-600 text-white font-bold mx-4 w-full py-2 px-6 rounded-full flex justify-center items-center`} onClick={this.reset}>
                    <MdReplay className="mr-2" />
                    Reset
                  </button>
                : null
            }
          </div>
        </div>
      </Modal>
    )
  }
}

ScanQrModal.propTypes = {
  isOpen: PropTypes.bool,
};

ScanQrModal.defaultProps = {
  isOpen: false,
};

export default ScanQrModal;